<ng-container *vsLet="viewModel$ | async as view">
  <div *ngIf="!view && showLoading" class="flex flex-col gap-2 w-48 animate-pulse">
    <div class="h-4 rounded bg-gray-200"></div>
    <div class="h-4 w-3/4 rounded bg-gray-200"></div>
  </div>

  <div *ngIf="view" class="flex flex-col gap-1 text-gray-600 text-start text-xs max-w-full">
    <ng-container *ngIf="firstOnly; else all">
      <ng-container *ngIf="view.orderedAssignments[0] as assignment">
        <ng-container
          [ngTemplateOutlet]="assignmentTpl"
          [ngTemplateOutletContext]="{ assignment: assignment, view: view }"
        ></ng-container>
      </ng-container>
    </ng-container>

    <ng-template #all>
      <ng-container *ngFor="let assignment of view.orderedAssignments">
        <ng-container
          [ngTemplateOutlet]="assignmentTpl"
          [ngTemplateOutletContext]="{ assignment: assignment, view: view }"
        ></ng-container>
      </ng-container>
    </ng-template>
  </div>

  <ng-template #assignmentTpl let-assignment="assignment" let-view="view">
    <ng-container *ngIf="assignment.kind === 'PROPERTY'">
      <vs-property-value-item
        [showHidden]="showHidden"
        [assignment]="assignment.propertyAssignment"
        [propertyValue]="view.propertyValues[assignment.propertyAssignment.property!.valueKey]"
        [showMissingRequired]="view.showMissingRequired"
        [missingIds]="view.missingIds"
        [showMissing]="
          view.showMissingRequired &&
          isMissingValue(view.propertyValues[assignment.propertyAssignment.property!.valueKey]) &&
          view.missingIds.has(assignment.propertyAssignment.propertyId)
        "
      >
      </vs-property-value-item>
    </ng-container>

    <ng-container *ngIf="assignment.kind === 'DIMENSION' && assignment.dimensionAssignment.dimension as dimension">
      <ng-container
        *ngIf="!isMissingValue(view.dimensionValues[assignment.dimensionAssignment.dimensionId]); else missingDimension"
      >
        <div class="flex">
          <vs-badge theme="default" class="self-center mr-1">{{ dimension.title }}</vs-badge>
          <span class="truncate">{{
            displayDimensionValue(
              assignment.dimensionAssignment.dimensionId,
              view.dimensionValues[assignment.dimensionAssignment.dimensionId],
              view.dimensionElements
            )
          }}</span>
        </div>
      </ng-container>
      <ng-template #missingDimension>
        <div
          class="flex"
          *ngIf="
            view.showMissingRequired &&
            isMissingValue(view.dimensionValues[assignment.dimensionAssignment.dimensionId]) &&
            view.missingIds.has(assignment.dimensionAssignment.dimensionId)
          "
        >
          <vs-badge theme="danger" class="self-center mr-1">{{ dimension.title }}</vs-badge>
          <span class="truncate text-danger">Required</span>
        </div>
      </ng-template>
    </ng-container>
  </ng-template>
</ng-container>
